<template>
  <div class="myinfo">
    <div class="myinfo-heading">
      <h2>{{ trans.text.myInfo.hello }}, {{ user.f_name }} {{ user.l_name }}</h2>
      <p>{{ trans.text.myInfo.keepInfo }}</p>
    </div>

    <div class="myinfo-form">
      <div class="inp-group">
        <label for="myinfo-fn">{{ trans.text.myInfo.firstName }}</label>
        <input id="myinfo-fn" v-model="user.f_name" class="inp-style inp-fw" name="#" type="text">
      </div>

      <div class="inp-group">
        <label for="myinfo-ln">{{ trans.text.myInfo.lastName }}</label>
        <input id="myinfo-ln" v-model="user.l_name" class="inp-style inp-fw" name="#" type="text">
      </div>

      <div class="inp-group flex">
        <label class="mb2x">{{ trans.text.myInfo.gender }}</label>
        <div class="inp-row">

          <label
            :class="{active: user.gender === 'female'}"
            class="inp-line gender-radio-label"
            for="female-gender"
          >
            <input
              id='female-gender'
              v-model="user.gender"
              class="inp-decorate female gender-radio"
              name="gender"
              type="radio"
              value="female">
            <span>{{ trans.text.myInfo.female }}</span>
          </label>

          <label
            :class="{active: user.gender === 'male'}"
            class="inp-line gender-radio-label"
            for="male-gender"
          >
            <input
              id='male-gender'
              v-model="user.gender"
              class="inp-decorate male gender-radio"
              name="gender"
              type="radio"
              value="male">
            <span>{{ trans.text.myInfo.male }}</span>
          </label>

          <label
            :class="{active: user.gender === 'free'}"
            class="inp-line gender-radio-label"
            for="free-gender"
          >
            <input
              id='free-gender'
              v-model="user.gender"
              class="inp-decorate free gender-radio"
              name="gender"
              type="radio"
              value="free">
            <span>{{ trans.text.myInfo.free }}</span>
          </label>
        </div>
      </div>

      <div class="inp-group">
        <label for="myinfo-email">{{ trans.text.myInfo.email }}</label>
        <input id="myinfo-email" v-model="user.email" class="inp-style inp-fw" name="#" type="email">
        <div v-if="!(!!user.email_verified_at)" class="error-text-custom">
          {{ trans.text.myInfo.emailNotVerified }} <a class="black-link" href="#" @click.prevent="resendLink()">
          ({{ trans.text.myInfo.redensEmailLink }})
        </a>
        </div>
      </div>

      <div class="inp-group">
        <label for="myinfo-mobile">{{ trans.text.myInfo.mobile }}</label>
        <input
          id="myinfo-mobile"
          v-model="user.mobile_phone"
          v-mask="'+###############'"
          class="inp-style inp-fw"
          name="#"
          type="tel">
      </div>

      <div class="inp-group">
        <label for="myinfo-date">{{ trans.text.myInfo.dob }}</label>
        <date-picker
          id="myinfo-date" v-model="user.birth_date"
          :format="'DD.MM.YYYY'"
          :lang="datePikerLang"
          input-class="inp-style inp-fw"
          type="date" valueType="YYYY-MM-DD"/>
      </div>


      <div class="inp-group">
        <label>Preferred language for communication</label>
        <multiselect
          v-model="language"
          :allow-empty="false"
          :label="'title'"
          :limit="5"
          :options="languages"
          :preselect-first="true"
          :searchable="false"
          :showNoResults="false"
          :track-by="'id'"
          deselectLabel=""
          selectLabel=""
          selectedLabel="">
        </multiselect>
      </div>


      <span v-if="success" class="resultVal">{{ success }}</span>
      <span v-if="error" class="resultVal error">{{ error }}</span>
      <div class="inp-group__checkbox-typical">
        <input id="ad-mailing" v-model="user.ad_mailings" class="inp-group__checkbox" type="checkbox">
        <label for="ad-mailing">
          <span class="checkbox"></span>
          <span>{{ trans.text.myInfo.adNews }}</span>
        </label>
      </div>

      <div class="myinfo-btns">
        <button class="btn btn-green btn-submit" @click="updateInfo">{{ trans.text.myInfo.save }}</button>
        <button class="btn btn-gray btn-submit" @click="submit">{{ trans.text.myInfo.logout }}</button>
      </div>

    </div>
  </div>
</template>

<script>

import DatePicker from "vue2-datepicker";
import datePickerRu from "vue2-datepicker/locale/ru";
import datePickerEn from "vue2-datepicker/locale/en";
import datePickerDe from "vue2-datepicker/locale/de";
import datePickerEs from "vue2-datepicker/locale/es";
import datePickerFr from "vue2-datepicker/locale/fr";
import 'vue2-datepicker/index.css';
import {mapActions} from "vuex";
import Multiselect from 'vue-multiselect';

export default {
  components: {Multiselect, DatePicker},
  props: ['lang', 'trans'],
  data() {
    return {
      datePikerLangs: [
        {
          id: 'en',
          locale: datePickerEn,
        },
        {
          id: 'es',
          locale: datePickerEs,
        },
        {
          id: 'de',
          locale: datePickerDe,
        },
        {
          id: 'fr',
          locale: datePickerFr,
        },
        {
          id: 'ru',
          locale: datePickerRu,
        },
      ],
      datePikerLang: datePickerEn,
      user: {
        birth_date: "",
        email: "",
        f_name: "",
        l_name: "",
        gender: "",
        mobile_phone: '',
        email_verified_at: null,
        ad_mailings: false
      },
      success: '',
      error: '',
      language: null,
      languages: []
    }
  },
  methods: {
    ...mapActions(['ResendVerificationLink', 'Logout']),
    setLanguageList() {
      let languages = [
        {
          id: 'en',
        },
        {
          id: 'de',
        },
        {
          id: 'fr',
        },
        {
          id: 'es',
        }
      ]

      this.languages = languages.map(item => {
        item.title = this.trans.text.myInfo.languages[item.id]
        return item
      })
    },
    setDatepickerLang() {
      for (let datePikerLang of this.datePikerLangs) {
        if (this.lang === datePikerLang.id) {
          this.datePikerLang = datePikerLang.locale
        }
      }
    },
    getInfo() {
      let that = this;
      axios
        .get(this.$path + '/user', {headers: {Authorization: 'Bearer ' + localStorage.getItem('access_token')}})
        .then(response => {
          that.user.f_name = response.data.f_name;
          that.user.l_name = response.data.l_name;
          that.user.gender = response.data.gender;
          that.user.email = response.data.email;
          that.user.ad_mailings = !!response.data.ad_mailings;
          that.user.email_verified_at = response.data.email_verified_at;
          that.user.mobile_phone = response.data.mobile_phone;
          that.user.birth_date = response.data.birth_date ? response.data.birth_date.split(' ')[0] : response.data.birth_date;
          that.languages.forEach(function (lang) {
            if (response.data.lang === lang.id) {
              that.language = lang
            }
          })

          localStorage.setItem('user', JSON.stringify(response.data));
        })
    },
    updateInfo() {
      let that = this;
      axios
        .put(this.$path + '/updateUserInfo', {
            'f_name': this.user.f_name,
            'l_name': this.user.l_name,
            'gender': this.user.gender,
            'email': this.user.email,
            'mobile_phone': this.user.mobile_phone,
            'birth_date': this.user.birth_date,
            'ad_mailings': this.user.ad_mailings,
            'lang': that.language.id
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('access_token')
            }
          })
        .then(response => {
          that.success = that.trans.text.myInfo.successUpdate;
          that.error = '';

          that.user.f_name = response.data.user.f_name;
          that.user.l_name = response.data.user.l_name;
          that.user.gender = response.data.user.gender;
          if (!response.data.email_request_sent) {
            that.user.email = response.data.user.email;
          }
          that.user.ad_mailings = response.data.user.ad_mailings;
          that.user.email_verified_at = response.data.user.email_verified_at;
          that.user.mobile_phone = response.data.user.mobile_phone;
          that.user.birth_date = response.data.user.birth_date ? response.data.user.birth_date.split(' ')[0] : response.data.user.birth_date;


          $('.' + response.data.user.gender).addClass('checked');

          this.$store.commit('updateAuthUser', response.data.user);

          localStorage.setItem('user', JSON.stringify(response.data.user));

          setTimeout(() => {
            this.success = null;
            this.error = null;
          }, 5000)
        })
        .catch(err => {
          if (err.response.data && err.response.data.errors.email) {
            that.error = err.response.data.errors.email[0]
          }
          that.success = ''

          setTimeout(() => {
            this.success = null;
            this.error = null;
          }, 5000)
        })
    },
    changeGender(gender) {
      this.user.gender = gender
    },
    resendLink() {
      this.ResendVerificationLink({
        path: this.$path
      }).then(result => {
        if (result === 200) {
          this.success = this.trans.text.myInfo.linkSent;
          this.error = null;
        }
        if (result === 429) {
          this.success = null;
          this.error = this.trans.text.myInfo.manyAttempts;
        }
        if (result === 500) {
          this.success = null;
          this.error = this.trans.text.myInfo.serverError;
        }

        setTimeout(() => {
          this.success = null;
          this.error = null;
        }, 5000)
      });
    },
    submit() {
      this.Logout({
        path: this.$path,
        lang: this.lang
      })
    },
  },
  mounted() {
    this.setLanguageList()
    this.setDatepickerLang();
    if (!localStorage.getItem('access_token')) {
      location.href = `/${this.lang}/login`
    } else {
      this.getInfo();
    }
  }

}
</script>
<style lang="scss" scoped>
.inp-success__text {
  font-size: 14px;
  color: #000;
  /*color: #49cc90;*/
}

.resultVal {
  margin-bottom: 72px;
  display: block;
  margin-top: 36px;

  & + .inp-group__checkbox-typical {
    display: none;
  }
}

.error {
  font-size: 14px;
  color: #E41B1B;
}

.mx-datepicker {
  width: 100%;
}

.error-text-custom {
  padding-top: 7px;
  font-size: 14px;
  color: #E41B1B;
}

.black-link {
  color: #000000;

  &:hover {
    color: #979797;
  }
}

.gender-radio-label {
  position: relative;
  padding-left: 30px;
  height: 26px;

  &:before {
    content: '';
    border-radius: 50%;
    width: 26px;
    height: 26px;
    background: #efefef;
    position: absolute;
    left: 0;
    top: 0;
  }

  &.active {
    &:after {
      content: '';
      border-radius: 50%;
      width: 14px;
      height: 14px;
      background: #c2e900;
      position: absolute;
      left: 6px;
      top: 6px;
    }
  }

  input {
    display: none;
  }
}
</style>
